// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-cell-container {
    display: flex;
    justify-content: space-between;
    column-gap: 5%;
    width: 100%;
    font-family: Lato;
}

.title-cell-description {
    font-size: 10px;
    color: #585858;
    line-height: 15px;
    font-style: normal;
    font-weight: 400;
}

.title-cell-targets {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    line-height: unset;
}

.title-cell-title-container {
    overflow: hidden;
    white-space: normal;
    word-break: break-word;
}

.title-cell-targets * {
    text-overflow: ellipsis;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    overflow: hidden;
    color: #2D2D2D;
    text-align: right;
    height: 30px;
}

.title-cell-title {
    padding-top: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #2D2D2D;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
}
`, "",{"version":3,"sources":["webpack://./client/components/product-collection/product-collection-views/product-collection-target-metrics/components/title-cell-renderer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB","sourcesContent":[".title-cell-container {\n    display: flex;\n    justify-content: space-between;\n    column-gap: 5%;\n    width: 100%;\n    font-family: Lato;\n}\n\n.title-cell-description {\n    font-size: 10px;\n    color: #585858;\n    line-height: 15px;\n    font-style: normal;\n    font-weight: 400;\n}\n\n.title-cell-targets {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    line-height: unset;\n}\n\n.title-cell-title-container {\n    overflow: hidden;\n    white-space: normal;\n    word-break: break-word;\n}\n\n.title-cell-targets * {\n    text-overflow: ellipsis;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 22px;\n    overflow: hidden;\n    color: #2D2D2D;\n    text-align: right;\n    height: 30px;\n}\n\n.title-cell-title {\n    padding-top: 5px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: #2D2D2D;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
